(function() {
'use strict';

angular
    .module('TR')
    .config(configOuter);

function configOuter($provide) {
    $provide.decorator('$http', http);
    http.$inject = ['$delegate', 'errInterceptor'];

    function http($http, errInterceptor) {
        const customHttp = function(config) {
            handleErrorCallback(config);
            return $http(config);
        };

        for (const prop in $http) {
            if (typeof ($http[prop]) === 'function') {
                customHttp[prop] =
                    (function(name) {
                        return function(...args) {
                            handleErrorCallback(args[args.length - 1]);
                            return $http[name](...args);
                        };
                    })(prop);
            } else {
                customHttp[prop] = $http[prop];
            }
        }

        function handleErrorCallback(config) {
            if (!config || typeof (config) !== 'object') {
                return;
            }

            if (config.ignoreErrors) {
                config.customErrCallback = angular.noop;
            }

            if (config.customErrCallback) {
                const _id = errInterceptor.addErrCallback(config.customErrCallback);
                const _customHeader = { 'x-callback': _id };

                delete config.customErrCallback;
                config.headers = angular.extend(config.headers || {}, _customHeader);
            }
        }

        return customHttp;
    }
}
})();
